import request from 'utils/request'
import {stringify} from 'qs'
import api from './api'

// 离职继承统计列表
export async function getResignList(payload) {
    return request(`${api.getResignList.url}?${stringify(payload)}`)
}

// 离职继承统计总览
export async function getResignStat() {
    return request(api.getResignStat.url)
}

// 导出数据
export async function exportData(params) {
    return request(`${api.exportData.url}${stringify(params, {addQueryPrefix: true})}`, null, {
        returnResponse: true,
    })
}
